<mat-drawer #drawer [opened]="true" class="example-sidenav" mode="side">
    <!-- <div class="logo-container">
      <img src="../assets/LogoCEC.png" class="logo" />
    </div> -->
    <mat-divider></mat-divider>
    <div class="profile">
       <img src="https://profaci.com.br/l/custom/img/depoimentos/boy-avatar.png"/>
       <div class="profile-name">
         <h3 style="font-size: larger;">{{user}}&#9660; </h3>
       </div>
    </div>
    <mat-divider></mat-divider>
    <div class="menu-list">
      <div class="menu-item" [routerLink]="['/dashboard']" [routerLinkActive]="['menu-item-active']">
        <img src="../assets/icons/people1.svg" class="menu-icon" />
        <div class="menu-title">
          <p>home</p>
        </div>
      </div>
      <div class="menu-item" [routerLink]="['/membros']" [routerLinkActive]="['menu-item-active']">
        <img src="../assets/icons/people1.svg" class="menu-icon" />
        <p>membros</p>
      </div>
      <div class="menu-item" [routerLink]="['/areas']" [routerLinkActive]="['menu-item-active']">
        <img src="../assets/icons/people1.svg" class="menu-icon" />
        <p>areas</p>
      </div>
      <div class="menu-item" [routerLink]="['/setor']" [routerLinkActive]="['menu-item-active']">
        <img src="../assets/icons/people1.svg" class="menu-icon" />
        <p>setor</p>
      </div>
    </div>
  </mat-drawer>